'use client';

import { useEffect, useState } from 'react';
import CompanyDescription from './CompanyDescription';
import InfoBox from './InfoBox';
import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';


const AboutUsInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const companyData = {
    title: t('aboutUs.company.title'),
    content: [t('aboutUs.company.description')]
  };

  const infoBoxData = {
    title: t('aboutUs.values.title'),
    items: [
    {
      icon: "ShieldCheckIcon",
      title: t('aboutUs.values.trust.title'),
      description: t('aboutUs.values.trust.description')
    },
    {
      icon: "BuildingLibraryIcon",
      title: t('aboutUs.values.quality.title'),
      description: t('aboutUs.values.quality.description')
    },
    {
      icon: "DocumentCheckIcon",
      title: t('aboutUs.values.service.title'),
      description: t('aboutUs.values.service.description')
    }]

  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-secondary">
        <div className="mx-auto max-w-content px-6 lg:px-8 py-16 lg:py-20">
          <div className="animate-pulse space-y-8">
            <div className="h-12 bg-muted rounded-md w-1/3"></div>
            <div className="space-y-4">
              <div className="h-6 bg-muted rounded"></div>
              <div className="h-6 bg-muted rounded"></div>
              <div className="h-6 bg-muted rounded w-5/6"></div>
            </div>
          </div>
        </div>
      </div>);

  }

  return (
    <div className="min-h-screen bg-secondary relative overflow-hidden">
      <div className="mx-auto max-w-content px-6 lg:px-8 py-16 lg:py-20 relative z-10">
        <div className="text-center mb-16 lg:mb-20">
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-primary mb-6 tracking-tight">
            {t('aboutUs.title')}
          </h1>
          <p className="font-body text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t('aboutUs.subtitle')}
          </p>
          <div className="w-24 h-1 bg-gradient-gold mx-auto mt-8 rounded-full" />
        </div>

        <CompanyDescription title={companyData?.title} content={companyData?.content} />

        <InfoBox title={infoBoxData?.title} items={infoBoxData?.items} />

        <div className="mt-16 flex flex-col sm:flex-row gap-5 justify-center">
          <CTAButton href="/contact" variant="primary" className="px-8 py-4 text-lg font-semibold">
            {t('common.contactUs')}
          </CTAButton>
          <CTAButton href="/products" variant="secondary" className="px-8 py-4 text-lg font-semibold">
            {t('common.viewProducts')}
          </CTAButton>
        </div>
      </div>
    </div>);

};

export default AboutUsInteractive;